/**
 * Activity history (the member ↔ company conversation messages) is stored in DynamoDB
 * with a 90-day TTL — app-api's `Conversation::EXPIRATION_DAYS` and the `expiration`
 * attribute every `ConversationMessage` is written with. An empty feed for something
 * last seen longer ago than that is the rows having expired, not "nothing happened",
 * so the empty state says so rather than promising activity is on its way.
 */
export const ACTIVITY_RETENTION_DAYS = 90;

const DAY_MS = 24 * 60 * 60 * 1000;

/** True when `lastSeenAt` is a valid date more than the retention window before `now`. */
export const isActivityPurged = (lastSeenAt: string | null | undefined, now: Date = new Date()): boolean => {
    if (!lastSeenAt) return false;
    const seen = new Date(lastSeenAt).getTime();
    if (Number.isNaN(seen)) return false;
    return now.getTime() - seen > ACTIVITY_RETENTION_DAYS * DAY_MS;
};

export const PURGED_ACTIVITY_TITLE = 'Activity History Cleared';

export const PURGED_ACTIVITY_MESSAGE =
    `For your privacy, we delete detailed activity history after ${ACTIVITY_RETENTION_DAYS} days. ` +
    'We still track this exposure and will act again if it returns.';
